// components/CountdownBanner/styles.js
import styled from 'styled-components';
import bgEvent from '../../images/backgroundEvento.png';

export const Background = styled.div`
  background-image: url(${bgEvent});
  background-color: ${(props) => props.theme.degradeAzul};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: white;
  padding: 16px 24px;
  display: flex;
  justify-content: center;
  gap: 50px;
  align-items: center;
  font-family: sans-serif;
  font-weight: bold;
  font-size: 14px;
  flex-wrap: wrap;
  text-align: center;

  @media (max-width: 768px) {
    gap: 20px;
    font-size: 13px;
    padding: 24px 16px;
  }

  @media (max-width: 480px) {
    gap: 16px;
    font-size: 13px;
    padding: 20px 12px;
  }
`;

export const Title = styled.span`
  color: #00ff88;
  margin-right: 32px;

  @media (max-width: 768px) {
    margin-right: 0;
  }
`;

export const Text = styled.span`
  margin-right: 8px;

  @media (max-width: 768px) {
    margin-right: 8px;
  }
`;

export const TimeSegment = styled.span`
  color: #00ff88;
  margin: 0 4px;

  span {
    color: white;
    margin-left: 2px;
  }
`;

export const Link = styled.a`
  display: flex;
  gap: 5px;
  text-decoration: none;
  color: #fff;
  justify-content: center;

  span {
    color: #00ff88;
    text-decoration: underline;
  }

  @media (max-width: 768px) {
    justify-content: center;
    flex-direction: row;
  }
`;
